// @generated by protobuf-ts 2.11.1 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "domains/vlp-notification/vlp-notification-definition-model.proto" (package "vlp.notification", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message vlp.notification.NotificationMailProfileDTO
 */
export interface NotificationMailProfileDTO {
    /**
     * @generated from protobuf field: int64 notification_mail_profile_id = 1
     */
    notificationMailProfileId: number;
    /**
     * @generated from protobuf field: int64 tenant_id = 2
     */
    tenantId: number;
    /**
     * @generated from protobuf field: int64 organization_unit_id = 3
     */
    organizationUnitId: number; // 0 = whole tenant
    /**
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationMailTransport transport = 5
     */
    transport: eNotificationMailTransport;
    /**
     * @generated from protobuf field: string host = 6
     */
    host: string;
    /**
     * @generated from protobuf field: int32 port = 7
     */
    port: number;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationMailSecurityMode security_mode = 8
     */
    securityMode: eNotificationMailSecurityMode;
    /**
     * @generated from protobuf field: string username = 9
     */
    username: string;
    /**
     * @generated from protobuf field: string from_address = 10
     */
    fromAddress: string;
    /**
     * @generated from protobuf field: string from_name = 11
     */
    fromName: string;
    /**
     * @generated from protobuf field: string reply_to = 12
     */
    replyTo: string;
    /**
     * @generated from protobuf field: bool has_stored_credential = 13
     */
    hasStoredCredential: boolean; // write-only secret is never returned
    /**
     * @generated from protobuf field: bool enabled = 14
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_tested_at = 15
     */
    lastTestedAt?: Timestamp;
    /**
     * @generated from protobuf field: string last_test_status = 16
     */
    lastTestStatus: string;
    /**
     * @generated from protobuf field: string last_error_code = 17
     */
    lastErrorCode: string;
    /**
     * @generated from protobuf field: bool effective_for_scope = 18
     */
    effectiveForScope: boolean;
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: string description = 22
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Catalog: một loại notification/alert với ownership + severity + runbook (thay AlertType chỉ có Name).
 *
 * @generated from protobuf message vlp.notification.NotificationDefinitionDTO
 */
export interface NotificationDefinitionDTO {
    /**
     * @generated from protobuf field: int64 notification_definition_id = 1
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: string code = 2
     */
    code: string; // ổn định, UPPER_SNAKE (VD WALLET_BALANCE_LOW)
    /**
     * @generated from protobuf field: vlp.notification.eNotificationCategory category = 3
     */
    category: eNotificationCategory;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationSeverity severity = 4
     */
    severity: eNotificationSeverity;
    /**
     * @generated from protobuf field: string owner_team = 5
     */
    ownerTeam: string; // PlatformOps/DBA/Security/Business...
    /**
     * @generated from protobuf field: bool mandatory = 6
     */
    mandatory: boolean; // true = user không tắt được (security/financial-integrity)
    /**
     * @generated from protobuf field: repeated vlp.notification.eNotificationChannel default_channels = 7
     */
    defaultChannels: eNotificationChannel[];
    /**
     * @generated from protobuf field: string runbook_url = 8
     */
    runbookUrl: string;
    /**
     * @generated from protobuf field: int32 version = 9
     */
    version: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp effective_from = 10
     */
    effectiveFrom?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp effective_to = 11
     */
    effectiveTo?: Timestamp;
    /**
     * @generated from protobuf field: string title = 12
     */
    title: string; // tên hiển thị catalog
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: string description = 22
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Rule kế thừa Platform default (tenant=0,unit=0) -> Tenant override -> OrganizationUnit override.
 *
 * @generated from protobuf message vlp.notification.NotificationRuleDTO
 */
export interface NotificationRuleDTO {
    /**
     * @generated from protobuf field: int64 notification_rule_id = 1
     */
    notificationRuleId: number;
    /**
     * @generated from protobuf field: int64 notification_definition_id = 2
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: int64 tenant_id = 3
     */
    tenantId: number; // 0 = platform default
    /**
     * @generated from protobuf field: int64 organization_unit_id = 4
     */
    organizationUnitId: number; // 0 = mọi unit trong tenant
    /**
     * @generated from protobuf field: bool enabled = 5
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string threshold_json = 6
     */
    thresholdJson: string; // ngưỡng/window typed theo definition
    /**
     * @generated from protobuf field: int32 cooldown_minutes = 7
     */
    cooldownMinutes: number; // P3 cooldown/digest
    /**
     * @generated from protobuf field: int32 group_wait_seconds = 8
     */
    groupWaitSeconds: number;
    /**
     * @generated from protobuf field: int32 repeat_minutes = 9
     */
    repeatMinutes: number; // P1/P2 repeat đến khi ack
    /**
     * @generated from protobuf field: int32 escalation_after_minutes = 10
     */
    escalationAfterMinutes: number; // 0 = không escalate
    /**
     * @generated from protobuf field: int32 priority = 11
     */
    priority: number;
    /**
     * @generated from protobuf field: int32 version = 12
     */
    version: number;
    /**
     * @generated from protobuf field: repeated vlp.notification.NotificationRecipientRuleDTO recipients = 13
     */
    recipients: NotificationRecipientRuleDTO[];
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: string description = 22
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message vlp.notification.NotificationRecipientRuleDTO
 */
export interface NotificationRecipientRuleDTO {
    /**
     * @generated from protobuf field: int64 notification_recipient_rule_id = 1
     */
    notificationRecipientRuleId: number;
    /**
     * @generated from protobuf field: int64 notification_rule_id = 2
     */
    notificationRuleId: number;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationRecipientType recipient_type = 3
     */
    recipientType: eNotificationRecipientType;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationRecipientRole recipient_role = 4
     */
    recipientRole: eNotificationRecipientRole; // khi type = ROLE
    /**
     * @generated from protobuf field: int64 recipient_value_id = 5
     */
    recipientValueId: number; // account/group/contact id khi type khác ROLE
    /**
     * @generated from protobuf field: vlp.notification.eNotificationScopeMode scope_mode = 6
     */
    scopeMode: eNotificationScopeMode;
    /**
     * @generated from protobuf field: repeated vlp.notification.eNotificationChannel channels = 7
     */
    channels: eNotificationChannel[]; // rỗng = dùng default_channels của definition
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message vlp.notification.NotificationTemplateDTO
 */
export interface NotificationTemplateDTO {
    /**
     * @generated from protobuf field: int64 notification_template_id = 1
     */
    notificationTemplateId: number;
    /**
     * @generated from protobuf field: int64 notification_definition_id = 2
     */
    notificationDefinitionId: number;
    /**
     * @generated from protobuf field: vlp.notification.eNotificationChannel channel = 3
     */
    channel: eNotificationChannel;
    /**
     * @generated from protobuf field: string language = 4
     */
    language: string; // vi/en
    /**
     * @generated from protobuf field: string subject_template = 5
     */
    subjectTemplate: string; // token {PlaceHolder} từ payload
    /**
     * @generated from protobuf field: string body_template = 6
     */
    bodyTemplate: string;
    /**
     * @generated from protobuf field: int32 version = 7
     */
    version: number;
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
/**
 * Preference cá nhân — KHÔNG áp dụng được cho definition Mandatory.
 *
 * @generated from protobuf message vlp.notification.NotificationPreferenceDTO
 */
export interface NotificationPreferenceDTO {
    /**
     * @generated from protobuf field: int64 notification_preference_id = 1
     */
    notificationPreferenceId: number;
    /**
     * @generated from protobuf field: int64 account_id = 2
     */
    accountId: number;
    /**
     * @generated from protobuf field: int64 notification_definition_id = 3
     */
    notificationDefinitionId: number; // 0 = áp cho cả category
    /**
     * @generated from protobuf field: vlp.notification.eNotificationCategory category = 4
     */
    category: eNotificationCategory;
    /**
     * @generated from protobuf field: repeated vlp.notification.eNotificationChannel opt_in_channels = 5
     */
    optInChannels: eNotificationChannel[];
    /**
     * @generated from protobuf field: bool muted = 6
     */
    muted: boolean;
    /**
     * @generated from protobuf field: string quiet_hours_from = 7
     */
    quietHoursFrom: string; // "22:00" theo timezone
    /**
     * @generated from protobuf field: string quiet_hours_to = 8
     */
    quietHoursTo: string;
    /**
     * @generated from protobuf field: string timezone = 9
     */
    timezone: string;
    /**
     * @generated from protobuf field: bool active = 20
     */
    active: boolean;
    /**
     * @generated from protobuf field: bool archive = 21
     */
    archive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 23
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 24
     */
    updatedAt?: Timestamp;
}
// =====================================================================
// LUL-653 — Notification: catalog definition/rule/recipient/template/preference.
// Schema: Notification. Enum prefix theo tên (gen C# PascalCase đầy đủ).
// Nguyên tắc: event chỉ mang identifier + trusted scope; recipient resolve theo
// role/scope (Unit -> Tenant -> Platform default) — KHÔNG nhận email tự do từ producer.
// =====================================================================

/**
 * @generated from protobuf enum vlp.notification.eNotificationSeverity
 */
export enum eNotificationSeverity {
    /**
     * @generated from protobuf enum value: NOTIFICATION_SEVERITY_UNSPECIFIED = 0;
     */
    NOTIFICATION_SEVERITY_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SEVERITY_P1_CRITICAL = 1;
     */
    NOTIFICATION_SEVERITY_P1_CRITICAL = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SEVERITY_P2_HIGH = 2;
     */
    NOTIFICATION_SEVERITY_P2_HIGH = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SEVERITY_P3_WARNING = 3;
     */
    NOTIFICATION_SEVERITY_P3_WARNING = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SEVERITY_P4_INFO = 4;
     */
    NOTIFICATION_SEVERITY_P4_INFO = 4
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationCategory
 */
export enum eNotificationCategory {
    /**
     * @generated from protobuf enum value: NOTIFICATION_CATEGORY_UNSPECIFIED = 0;
     */
    NOTIFICATION_CATEGORY_UNSPECIFIED = 0,
    /**
     * Flow A — thông báo nghiệp vụ
     *
     * @generated from protobuf enum value: NOTIFICATION_CATEGORY_BUSINESS = 1;
     */
    NOTIFICATION_CATEGORY_BUSINESS = 1,
    /**
     * Flow B — cảnh báo hạ tầng/SLA
     *
     * @generated from protobuf enum value: NOTIFICATION_CATEGORY_OPERATIONAL = 2;
     */
    NOTIFICATION_CATEGORY_OPERATIONAL = 2,
    /**
     * mandatory, không silence sai phép
     *
     * @generated from protobuf enum value: NOTIFICATION_CATEGORY_SECURITY = 3;
     */
    NOTIFICATION_CATEGORY_SECURITY = 3
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationChannel
 */
export enum eNotificationChannel {
    /**
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_UNSPECIFIED = 0;
     */
    NOTIFICATION_CHANNEL_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_IN_APP = 1;
     */
    NOTIFICATION_CHANNEL_IN_APP = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_EMAIL = 2;
     */
    NOTIFICATION_CHANNEL_EMAIL = 2,
    /**
     * webhook (Teams/Slack/Google Chat)
     *
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_CHAT = 3;
     */
    NOTIFICATION_CHANNEL_CHAT = 3,
    /**
     * adapter provider ngoài
     *
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_SMS = 4;
     */
    NOTIFICATION_CHANNEL_SMS = 4,
    /**
     * on-call paging provider độc lập
     *
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_PAGER = 5;
     */
    NOTIFICATION_CHANNEL_PAGER = 5,
    /**
     * Push mobile (Expo Push -> FCM/APNs). Địa chỉ resolve ra là AccountId chứ không phải token:
     * một account có nhiều thiết bị, sender tự fan-out theo NotificationDevice đang active nên
     * recipient resolver vẫn chỉ sinh MỘT delivery cho mỗi (account, channel) như các channel khác.
     *
     * @generated from protobuf enum value: NOTIFICATION_CHANNEL_PUSH = 6;
     */
    NOTIFICATION_CHANNEL_PUSH = 6
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationRecipientType
 */
export enum eNotificationRecipientType {
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_UNSPECIFIED = 0;
     */
    NOTIFICATION_RECIPIENT_TYPE_UNSPECIFIED = 0,
    /**
     * resolve account theo role trong scope
     *
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_ROLE = 1;
     */
    NOTIFICATION_RECIPIENT_TYPE_ROLE = 1,
    /**
     * account id cụ thể
     *
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_USER = 2;
     */
    NOTIFICATION_RECIPIENT_TYPE_USER = 2,
    /**
     * account group
     *
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_GROUP = 3;
     */
    NOTIFICATION_RECIPIENT_TYPE_GROUP = 3,
    /**
     * contact point đã đăng ký (on-call rotation)
     *
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_CONTACT = 4;
     */
    NOTIFICATION_RECIPIENT_TYPE_CONTACT = 4,
    /**
     * account đã thực hiện thao tác sinh ra event (envelope.ActorAccountId)
     *
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_TYPE_ACTOR = 5;
     */
    NOTIFICATION_RECIPIENT_TYPE_ACTOR = 5
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationRecipientRole
 */
export enum eNotificationRecipientRole {
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_UNSPECIFIED = 0;
     */
    NOTIFICATION_RECIPIENT_ROLE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_TENANT_ADMIN = 1;
     */
    NOTIFICATION_RECIPIENT_ROLE_TENANT_ADMIN = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_MANAGER = 2;
     */
    NOTIFICATION_RECIPIENT_ROLE_MANAGER = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_ACCOUNTING = 3;
     */
    NOTIFICATION_RECIPIENT_ROLE_ACCOUNTING = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_OPERATOR = 4;
     */
    NOTIFICATION_RECIPIENT_ROLE_OPERATOR = 4,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_SALES = 5;
     */
    NOTIFICATION_RECIPIENT_ROLE_SALES = 5,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_AUDITOR = 6;
     */
    NOTIFICATION_RECIPIENT_ROLE_AUDITOR = 6,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_ON_CALL = 7;
     */
    NOTIFICATION_RECIPIENT_ROLE_ON_CALL = 7,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_SECURITY = 8;
     */
    NOTIFICATION_RECIPIENT_ROLE_SECURITY = 8,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_PLATFORM_OPS = 9;
     */
    NOTIFICATION_RECIPIENT_ROLE_PLATFORM_OPS = 9,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_CUSTOMER = 10;
     */
    NOTIFICATION_RECIPIENT_ROLE_CUSTOMER = 10,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_PLATFORM_ADMIN = 11;
     */
    NOTIFICATION_RECIPIENT_ROLE_PLATFORM_ADMIN = 11,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_PLATFORM_SUPPORT = 12;
     */
    NOTIFICATION_RECIPIENT_ROLE_PLATFORM_SUPPORT = 12,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_TENANT_SUPPORT = 13;
     */
    NOTIFICATION_RECIPIENT_ROLE_TENANT_SUPPORT = 13,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_ORGANIZATION_ADMIN = 14;
     */
    NOTIFICATION_RECIPIENT_ROLE_ORGANIZATION_ADMIN = 14,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_ADMIN = 15;
     */
    NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_ADMIN = 15,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_ACCOUNTING = 16;
     */
    NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_ACCOUNTING = 16,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_OPERATOR = 17;
     */
    NOTIFICATION_RECIPIENT_ROLE_CUSTOMER_OPERATOR = 17,
    /**
     * @generated from protobuf enum value: NOTIFICATION_RECIPIENT_ROLE_PICKUP_STAFF = 18;
     */
    NOTIFICATION_RECIPIENT_ROLE_PICKUP_STAFF = 18
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationScopeMode
 */
export enum eNotificationScopeMode {
    /**
     * @generated from protobuf enum value: NOTIFICATION_SCOPE_MODE_UNSPECIFIED = 0;
     */
    NOTIFICATION_SCOPE_MODE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SCOPE_MODE_CURRENT_UNIT = 1;
     */
    NOTIFICATION_SCOPE_MODE_CURRENT_UNIT = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SCOPE_MODE_UNIT_AND_DESCENDANTS = 2;
     */
    NOTIFICATION_SCOPE_MODE_UNIT_AND_DESCENDANTS = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SCOPE_MODE_WHOLE_TENANT = 3;
     */
    NOTIFICATION_SCOPE_MODE_WHOLE_TENANT = 3,
    /**
     * @generated from protobuf enum value: NOTIFICATION_SCOPE_MODE_CURRENT_ACCOUNT_GROUP = 4;
     */
    NOTIFICATION_SCOPE_MODE_CURRENT_ACCOUNT_GROUP = 4
}
/**
 * Outbound notification mail uses SMTP. IMAP/POP3 are inbound mailbox protocols and are intentionally
 * not accepted as a sending transport.
 *
 * @generated from protobuf enum vlp.notification.eNotificationMailTransport
 */
export enum eNotificationMailTransport {
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_TRANSPORT_UNSPECIFIED = 0;
     */
    NOTIFICATION_MAIL_TRANSPORT_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_TRANSPORT_SMTP = 1;
     */
    NOTIFICATION_MAIL_TRANSPORT_SMTP = 1
}
/**
 * @generated from protobuf enum vlp.notification.eNotificationMailSecurityMode
 */
export enum eNotificationMailSecurityMode {
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_SECURITY_MODE_UNSPECIFIED = 0;
     */
    NOTIFICATION_MAIL_SECURITY_MODE_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_SECURITY_MODE_STARTTLS = 1;
     */
    NOTIFICATION_MAIL_SECURITY_MODE_STARTTLS = 1,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_SECURITY_MODE_TLS = 2;
     */
    NOTIFICATION_MAIL_SECURITY_MODE_TLS = 2,
    /**
     * @generated from protobuf enum value: NOTIFICATION_MAIL_SECURITY_MODE_NONE = 3;
     */
    NOTIFICATION_MAIL_SECURITY_MODE_NONE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class NotificationMailProfileDTO$Type extends MessageType<NotificationMailProfileDTO> {
    constructor() {
        super("vlp.notification.NotificationMailProfileDTO", [
            { no: 1, name: "notification_mail_profile_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "transport", kind: "enum", T: () => ["vlp.notification.eNotificationMailTransport", eNotificationMailTransport] },
            { no: 6, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "port", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "security_mode", kind: "enum", T: () => ["vlp.notification.eNotificationMailSecurityMode", eNotificationMailSecurityMode] },
            { no: 9, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "from_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "from_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "reply_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "has_stored_credential", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "last_tested_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "last_test_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "last_error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "effective_for_scope", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationMailProfileDTO>): NotificationMailProfileDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationMailProfileId = 0;
        message.tenantId = 0;
        message.organizationUnitId = 0;
        message.displayName = "";
        message.transport = 0;
        message.host = "";
        message.port = 0;
        message.securityMode = 0;
        message.username = "";
        message.fromAddress = "";
        message.fromName = "";
        message.replyTo = "";
        message.hasStoredCredential = false;
        message.enabled = false;
        message.lastTestStatus = "";
        message.lastErrorCode = "";
        message.effectiveForScope = false;
        message.active = false;
        message.archive = false;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<NotificationMailProfileDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationMailProfileDTO): NotificationMailProfileDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_mail_profile_id */ 1:
                    message.notificationMailProfileId = reader.int64().toNumber();
                    break;
                case /* int64 tenant_id */ 2:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* int64 organization_unit_id */ 3:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* vlp.notification.eNotificationMailTransport transport */ 5:
                    message.transport = reader.int32();
                    break;
                case /* string host */ 6:
                    message.host = reader.string();
                    break;
                case /* int32 port */ 7:
                    message.port = reader.int32();
                    break;
                case /* vlp.notification.eNotificationMailSecurityMode security_mode */ 8:
                    message.securityMode = reader.int32();
                    break;
                case /* string username */ 9:
                    message.username = reader.string();
                    break;
                case /* string from_address */ 10:
                    message.fromAddress = reader.string();
                    break;
                case /* string from_name */ 11:
                    message.fromName = reader.string();
                    break;
                case /* string reply_to */ 12:
                    message.replyTo = reader.string();
                    break;
                case /* bool has_stored_credential */ 13:
                    message.hasStoredCredential = reader.bool();
                    break;
                case /* bool enabled */ 14:
                    message.enabled = reader.bool();
                    break;
                case /* google.protobuf.Timestamp last_tested_at */ 15:
                    message.lastTestedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastTestedAt);
                    break;
                case /* string last_test_status */ 16:
                    message.lastTestStatus = reader.string();
                    break;
                case /* string last_error_code */ 17:
                    message.lastErrorCode = reader.string();
                    break;
                case /* bool effective_for_scope */ 18:
                    message.effectiveForScope = reader.bool();
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* string description */ 22:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationMailProfileDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_mail_profile_id = 1; */
        if (message.notificationMailProfileId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationMailProfileId);
        /* int64 tenant_id = 2; */
        if (message.tenantId !== 0)
            writer.tag(2, WireType.Varint).int64(message.tenantId);
        /* int64 organization_unit_id = 3; */
        if (message.organizationUnitId !== 0)
            writer.tag(3, WireType.Varint).int64(message.organizationUnitId);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* vlp.notification.eNotificationMailTransport transport = 5; */
        if (message.transport !== 0)
            writer.tag(5, WireType.Varint).int32(message.transport);
        /* string host = 6; */
        if (message.host !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.host);
        /* int32 port = 7; */
        if (message.port !== 0)
            writer.tag(7, WireType.Varint).int32(message.port);
        /* vlp.notification.eNotificationMailSecurityMode security_mode = 8; */
        if (message.securityMode !== 0)
            writer.tag(8, WireType.Varint).int32(message.securityMode);
        /* string username = 9; */
        if (message.username !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.username);
        /* string from_address = 10; */
        if (message.fromAddress !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.fromAddress);
        /* string from_name = 11; */
        if (message.fromName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.fromName);
        /* string reply_to = 12; */
        if (message.replyTo !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.replyTo);
        /* bool has_stored_credential = 13; */
        if (message.hasStoredCredential !== false)
            writer.tag(13, WireType.Varint).bool(message.hasStoredCredential);
        /* bool enabled = 14; */
        if (message.enabled !== false)
            writer.tag(14, WireType.Varint).bool(message.enabled);
        /* google.protobuf.Timestamp last_tested_at = 15; */
        if (message.lastTestedAt)
            Timestamp.internalBinaryWrite(message.lastTestedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string last_test_status = 16; */
        if (message.lastTestStatus !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.lastTestStatus);
        /* string last_error_code = 17; */
        if (message.lastErrorCode !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.lastErrorCode);
        /* bool effective_for_scope = 18; */
        if (message.effectiveForScope !== false)
            writer.tag(18, WireType.Varint).bool(message.effectiveForScope);
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* string description = 22; */
        if (message.description !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationMailProfileDTO
 */
export const NotificationMailProfileDTO = new NotificationMailProfileDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationDefinitionDTO$Type extends MessageType<NotificationDefinitionDTO> {
    constructor() {
        super("vlp.notification.NotificationDefinitionDTO", [
            { no: 1, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "category", kind: "enum", T: () => ["vlp.notification.eNotificationCategory", eNotificationCategory] },
            { no: 4, name: "severity", kind: "enum", T: () => ["vlp.notification.eNotificationSeverity", eNotificationSeverity] },
            { no: 5, name: "owner_team", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mandatory", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "default_channels", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 8, name: "runbook_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "effective_from", kind: "message", T: () => Timestamp },
            { no: 11, name: "effective_to", kind: "message", T: () => Timestamp },
            { no: 12, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationDefinitionDTO>): NotificationDefinitionDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationDefinitionId = 0;
        message.code = "";
        message.category = 0;
        message.severity = 0;
        message.ownerTeam = "";
        message.mandatory = false;
        message.defaultChannels = [];
        message.runbookUrl = "";
        message.version = 0;
        message.title = "";
        message.active = false;
        message.archive = false;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<NotificationDefinitionDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationDefinitionDTO): NotificationDefinitionDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_definition_id */ 1:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* vlp.notification.eNotificationCategory category */ 3:
                    message.category = reader.int32();
                    break;
                case /* vlp.notification.eNotificationSeverity severity */ 4:
                    message.severity = reader.int32();
                    break;
                case /* string owner_team */ 5:
                    message.ownerTeam = reader.string();
                    break;
                case /* bool mandatory */ 6:
                    message.mandatory = reader.bool();
                    break;
                case /* repeated vlp.notification.eNotificationChannel default_channels */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.defaultChannels.push(reader.int32());
                    else
                        message.defaultChannels.push(reader.int32());
                    break;
                case /* string runbook_url */ 8:
                    message.runbookUrl = reader.string();
                    break;
                case /* int32 version */ 9:
                    message.version = reader.int32();
                    break;
                case /* google.protobuf.Timestamp effective_from */ 10:
                    message.effectiveFrom = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.effectiveFrom);
                    break;
                case /* google.protobuf.Timestamp effective_to */ 11:
                    message.effectiveTo = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.effectiveTo);
                    break;
                case /* string title */ 12:
                    message.title = reader.string();
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* string description */ 22:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationDefinitionDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_definition_id = 1; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationDefinitionId);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* vlp.notification.eNotificationCategory category = 3; */
        if (message.category !== 0)
            writer.tag(3, WireType.Varint).int32(message.category);
        /* vlp.notification.eNotificationSeverity severity = 4; */
        if (message.severity !== 0)
            writer.tag(4, WireType.Varint).int32(message.severity);
        /* string owner_team = 5; */
        if (message.ownerTeam !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.ownerTeam);
        /* bool mandatory = 6; */
        if (message.mandatory !== false)
            writer.tag(6, WireType.Varint).bool(message.mandatory);
        /* repeated vlp.notification.eNotificationChannel default_channels = 7; */
        if (message.defaultChannels.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.defaultChannels.length; i++)
                writer.int32(message.defaultChannels[i]);
            writer.join();
        }
        /* string runbook_url = 8; */
        if (message.runbookUrl !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.runbookUrl);
        /* int32 version = 9; */
        if (message.version !== 0)
            writer.tag(9, WireType.Varint).int32(message.version);
        /* google.protobuf.Timestamp effective_from = 10; */
        if (message.effectiveFrom)
            Timestamp.internalBinaryWrite(message.effectiveFrom, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp effective_to = 11; */
        if (message.effectiveTo)
            Timestamp.internalBinaryWrite(message.effectiveTo, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string title = 12; */
        if (message.title !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.title);
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* string description = 22; */
        if (message.description !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationDefinitionDTO
 */
export const NotificationDefinitionDTO = new NotificationDefinitionDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationRuleDTO$Type extends MessageType<NotificationRuleDTO> {
    constructor() {
        super("vlp.notification.NotificationRuleDTO", [
            { no: 1, name: "notification_rule_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "tenant_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "organization_unit_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "threshold_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "cooldown_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "group_wait_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "repeat_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "escalation_after_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "recipients", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationRecipientRuleDTO },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationRuleDTO>): NotificationRuleDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationRuleId = 0;
        message.notificationDefinitionId = 0;
        message.tenantId = 0;
        message.organizationUnitId = 0;
        message.enabled = false;
        message.thresholdJson = "";
        message.cooldownMinutes = 0;
        message.groupWaitSeconds = 0;
        message.repeatMinutes = 0;
        message.escalationAfterMinutes = 0;
        message.priority = 0;
        message.version = 0;
        message.recipients = [];
        message.active = false;
        message.archive = false;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<NotificationRuleDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationRuleDTO): NotificationRuleDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_rule_id */ 1:
                    message.notificationRuleId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 2:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* int64 tenant_id */ 3:
                    message.tenantId = reader.int64().toNumber();
                    break;
                case /* int64 organization_unit_id */ 4:
                    message.organizationUnitId = reader.int64().toNumber();
                    break;
                case /* bool enabled */ 5:
                    message.enabled = reader.bool();
                    break;
                case /* string threshold_json */ 6:
                    message.thresholdJson = reader.string();
                    break;
                case /* int32 cooldown_minutes */ 7:
                    message.cooldownMinutes = reader.int32();
                    break;
                case /* int32 group_wait_seconds */ 8:
                    message.groupWaitSeconds = reader.int32();
                    break;
                case /* int32 repeat_minutes */ 9:
                    message.repeatMinutes = reader.int32();
                    break;
                case /* int32 escalation_after_minutes */ 10:
                    message.escalationAfterMinutes = reader.int32();
                    break;
                case /* int32 priority */ 11:
                    message.priority = reader.int32();
                    break;
                case /* int32 version */ 12:
                    message.version = reader.int32();
                    break;
                case /* repeated vlp.notification.NotificationRecipientRuleDTO recipients */ 13:
                    message.recipients.push(NotificationRecipientRuleDTO.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* string description */ 22:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationRuleDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_rule_id = 1; */
        if (message.notificationRuleId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationRuleId);
        /* int64 notification_definition_id = 2; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(2, WireType.Varint).int64(message.notificationDefinitionId);
        /* int64 tenant_id = 3; */
        if (message.tenantId !== 0)
            writer.tag(3, WireType.Varint).int64(message.tenantId);
        /* int64 organization_unit_id = 4; */
        if (message.organizationUnitId !== 0)
            writer.tag(4, WireType.Varint).int64(message.organizationUnitId);
        /* bool enabled = 5; */
        if (message.enabled !== false)
            writer.tag(5, WireType.Varint).bool(message.enabled);
        /* string threshold_json = 6; */
        if (message.thresholdJson !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.thresholdJson);
        /* int32 cooldown_minutes = 7; */
        if (message.cooldownMinutes !== 0)
            writer.tag(7, WireType.Varint).int32(message.cooldownMinutes);
        /* int32 group_wait_seconds = 8; */
        if (message.groupWaitSeconds !== 0)
            writer.tag(8, WireType.Varint).int32(message.groupWaitSeconds);
        /* int32 repeat_minutes = 9; */
        if (message.repeatMinutes !== 0)
            writer.tag(9, WireType.Varint).int32(message.repeatMinutes);
        /* int32 escalation_after_minutes = 10; */
        if (message.escalationAfterMinutes !== 0)
            writer.tag(10, WireType.Varint).int32(message.escalationAfterMinutes);
        /* int32 priority = 11; */
        if (message.priority !== 0)
            writer.tag(11, WireType.Varint).int32(message.priority);
        /* int32 version = 12; */
        if (message.version !== 0)
            writer.tag(12, WireType.Varint).int32(message.version);
        /* repeated vlp.notification.NotificationRecipientRuleDTO recipients = 13; */
        for (let i = 0; i < message.recipients.length; i++)
            NotificationRecipientRuleDTO.internalBinaryWrite(message.recipients[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* string description = 22; */
        if (message.description !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationRuleDTO
 */
export const NotificationRuleDTO = new NotificationRuleDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationRecipientRuleDTO$Type extends MessageType<NotificationRecipientRuleDTO> {
    constructor() {
        super("vlp.notification.NotificationRecipientRuleDTO", [
            { no: 1, name: "notification_recipient_rule_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "notification_rule_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "recipient_type", kind: "enum", T: () => ["vlp.notification.eNotificationRecipientType", eNotificationRecipientType] },
            { no: 4, name: "recipient_role", kind: "enum", T: () => ["vlp.notification.eNotificationRecipientRole", eNotificationRecipientRole] },
            { no: 5, name: "recipient_value_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "scope_mode", kind: "enum", T: () => ["vlp.notification.eNotificationScopeMode", eNotificationScopeMode] },
            { no: 7, name: "channels", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationRecipientRuleDTO>): NotificationRecipientRuleDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationRecipientRuleId = 0;
        message.notificationRuleId = 0;
        message.recipientType = 0;
        message.recipientRole = 0;
        message.recipientValueId = 0;
        message.scopeMode = 0;
        message.channels = [];
        message.active = false;
        message.archive = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationRecipientRuleDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationRecipientRuleDTO): NotificationRecipientRuleDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_recipient_rule_id */ 1:
                    message.notificationRecipientRuleId = reader.int64().toNumber();
                    break;
                case /* int64 notification_rule_id */ 2:
                    message.notificationRuleId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationRecipientType recipient_type */ 3:
                    message.recipientType = reader.int32();
                    break;
                case /* vlp.notification.eNotificationRecipientRole recipient_role */ 4:
                    message.recipientRole = reader.int32();
                    break;
                case /* int64 recipient_value_id */ 5:
                    message.recipientValueId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationScopeMode scope_mode */ 6:
                    message.scopeMode = reader.int32();
                    break;
                case /* repeated vlp.notification.eNotificationChannel channels */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.channels.push(reader.int32());
                    else
                        message.channels.push(reader.int32());
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationRecipientRuleDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_recipient_rule_id = 1; */
        if (message.notificationRecipientRuleId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationRecipientRuleId);
        /* int64 notification_rule_id = 2; */
        if (message.notificationRuleId !== 0)
            writer.tag(2, WireType.Varint).int64(message.notificationRuleId);
        /* vlp.notification.eNotificationRecipientType recipient_type = 3; */
        if (message.recipientType !== 0)
            writer.tag(3, WireType.Varint).int32(message.recipientType);
        /* vlp.notification.eNotificationRecipientRole recipient_role = 4; */
        if (message.recipientRole !== 0)
            writer.tag(4, WireType.Varint).int32(message.recipientRole);
        /* int64 recipient_value_id = 5; */
        if (message.recipientValueId !== 0)
            writer.tag(5, WireType.Varint).int64(message.recipientValueId);
        /* vlp.notification.eNotificationScopeMode scope_mode = 6; */
        if (message.scopeMode !== 0)
            writer.tag(6, WireType.Varint).int32(message.scopeMode);
        /* repeated vlp.notification.eNotificationChannel channels = 7; */
        if (message.channels.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.channels.length; i++)
                writer.int32(message.channels[i]);
            writer.join();
        }
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationRecipientRuleDTO
 */
export const NotificationRecipientRuleDTO = new NotificationRecipientRuleDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationTemplateDTO$Type extends MessageType<NotificationTemplateDTO> {
    constructor() {
        super("vlp.notification.NotificationTemplateDTO", [
            { no: 1, name: "notification_template_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "channel", kind: "enum", T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 4, name: "language", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "subject_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "body_template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationTemplateDTO>): NotificationTemplateDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationTemplateId = 0;
        message.notificationDefinitionId = 0;
        message.channel = 0;
        message.language = "";
        message.subjectTemplate = "";
        message.bodyTemplate = "";
        message.version = 0;
        message.active = false;
        message.archive = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationTemplateDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationTemplateDTO): NotificationTemplateDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_template_id */ 1:
                    message.notificationTemplateId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 2:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationChannel channel */ 3:
                    message.channel = reader.int32();
                    break;
                case /* string language */ 4:
                    message.language = reader.string();
                    break;
                case /* string subject_template */ 5:
                    message.subjectTemplate = reader.string();
                    break;
                case /* string body_template */ 6:
                    message.bodyTemplate = reader.string();
                    break;
                case /* int32 version */ 7:
                    message.version = reader.int32();
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationTemplateDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_template_id = 1; */
        if (message.notificationTemplateId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationTemplateId);
        /* int64 notification_definition_id = 2; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(2, WireType.Varint).int64(message.notificationDefinitionId);
        /* vlp.notification.eNotificationChannel channel = 3; */
        if (message.channel !== 0)
            writer.tag(3, WireType.Varint).int32(message.channel);
        /* string language = 4; */
        if (message.language !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.language);
        /* string subject_template = 5; */
        if (message.subjectTemplate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.subjectTemplate);
        /* string body_template = 6; */
        if (message.bodyTemplate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.bodyTemplate);
        /* int32 version = 7; */
        if (message.version !== 0)
            writer.tag(7, WireType.Varint).int32(message.version);
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationTemplateDTO
 */
export const NotificationTemplateDTO = new NotificationTemplateDTO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationPreferenceDTO$Type extends MessageType<NotificationPreferenceDTO> {
    constructor() {
        super("vlp.notification.NotificationPreferenceDTO", [
            { no: 1, name: "notification_preference_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "account_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "notification_definition_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "category", kind: "enum", T: () => ["vlp.notification.eNotificationCategory", eNotificationCategory] },
            { no: 5, name: "opt_in_channels", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["vlp.notification.eNotificationChannel", eNotificationChannel] },
            { no: 6, name: "muted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "quiet_hours_from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "quiet_hours_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "archive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<NotificationPreferenceDTO>): NotificationPreferenceDTO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationPreferenceId = 0;
        message.accountId = 0;
        message.notificationDefinitionId = 0;
        message.category = 0;
        message.optInChannels = [];
        message.muted = false;
        message.quietHoursFrom = "";
        message.quietHoursTo = "";
        message.timezone = "";
        message.active = false;
        message.archive = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationPreferenceDTO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationPreferenceDTO): NotificationPreferenceDTO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 notification_preference_id */ 1:
                    message.notificationPreferenceId = reader.int64().toNumber();
                    break;
                case /* int64 account_id */ 2:
                    message.accountId = reader.int64().toNumber();
                    break;
                case /* int64 notification_definition_id */ 3:
                    message.notificationDefinitionId = reader.int64().toNumber();
                    break;
                case /* vlp.notification.eNotificationCategory category */ 4:
                    message.category = reader.int32();
                    break;
                case /* repeated vlp.notification.eNotificationChannel opt_in_channels */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.optInChannels.push(reader.int32());
                    else
                        message.optInChannels.push(reader.int32());
                    break;
                case /* bool muted */ 6:
                    message.muted = reader.bool();
                    break;
                case /* string quiet_hours_from */ 7:
                    message.quietHoursFrom = reader.string();
                    break;
                case /* string quiet_hours_to */ 8:
                    message.quietHoursTo = reader.string();
                    break;
                case /* string timezone */ 9:
                    message.timezone = reader.string();
                    break;
                case /* bool active */ 20:
                    message.active = reader.bool();
                    break;
                case /* bool archive */ 21:
                    message.archive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 23:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 24:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationPreferenceDTO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 notification_preference_id = 1; */
        if (message.notificationPreferenceId !== 0)
            writer.tag(1, WireType.Varint).int64(message.notificationPreferenceId);
        /* int64 account_id = 2; */
        if (message.accountId !== 0)
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* int64 notification_definition_id = 3; */
        if (message.notificationDefinitionId !== 0)
            writer.tag(3, WireType.Varint).int64(message.notificationDefinitionId);
        /* vlp.notification.eNotificationCategory category = 4; */
        if (message.category !== 0)
            writer.tag(4, WireType.Varint).int32(message.category);
        /* repeated vlp.notification.eNotificationChannel opt_in_channels = 5; */
        if (message.optInChannels.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.optInChannels.length; i++)
                writer.int32(message.optInChannels[i]);
            writer.join();
        }
        /* bool muted = 6; */
        if (message.muted !== false)
            writer.tag(6, WireType.Varint).bool(message.muted);
        /* string quiet_hours_from = 7; */
        if (message.quietHoursFrom !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.quietHoursFrom);
        /* string quiet_hours_to = 8; */
        if (message.quietHoursTo !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.quietHoursTo);
        /* string timezone = 9; */
        if (message.timezone !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.timezone);
        /* bool active = 20; */
        if (message.active !== false)
            writer.tag(20, WireType.Varint).bool(message.active);
        /* bool archive = 21; */
        if (message.archive !== false)
            writer.tag(21, WireType.Varint).bool(message.archive);
        /* google.protobuf.Timestamp created_at = 23; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 24; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message vlp.notification.NotificationPreferenceDTO
 */
export const NotificationPreferenceDTO = new NotificationPreferenceDTO$Type();
